import { useCallback, useEffect, useState } from "react";
import { PERFORMANCE_LENS_ACCESS } from "../../../config/Endpoints.js";
import { getAuthToken } from "../../../utils/Storage.js";
import { getApi } from "../../utils/api.ts";

export type PerformanceLensAccess = {
  admin: boolean;
  transparency?: boolean;
  managedProjects: { id: number; name: string }[];
  hodProjects?: { id: number; name: string }[];
  name?: string;
  designation?: string;
};

export function usePerformanceLensAccess() {
  const [access, setAccess] = useState<PerformanceLensAccess | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refresh = useCallback(async (signal?: AbortSignal) => {
    setLoading(true);
    setError(false);
    try {
      const response = await getApi<PerformanceLensAccess>(
        PERFORMANCE_LENS_ACCESS,
        getAuthToken("accessToken"),
        "json",
        signal,
      );
      if (!signal?.aborted) setAccess(response.data);
    } catch {
      if (!signal?.aborted) {
        setAccess(null);
        setError(true);
      }
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    void refresh(controller.signal);
    return () => controller.abort();
  }, [refresh]);

  return { access, loading, error, refresh };
}
